import * as React from 'react'

import {
  Box,
  Button,
  Typography,
  InputAdornment,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Chip
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux';

import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { CTextField } from '../../components/common/TextField';
import { CActionButton, CPageButton, CPageArrowButton } from '../../components/common/Button'
import SourceModal from '../../modals/admin/SourceModal';

import { getSources, deleteSource, getSource } from '../../slices/source';

export default function Source() {
  const [openSource, setOpenSource] = React.useState(false);
  const [mode, setMode] = React.useState('Create');
  const dispatch = useDispatch();
  const sources = useSelector(state => state.source.sources);

  React.useEffect(() => {
    let formData = new FormData();
    formData.append("page", 1);
    dispatch(getSources(formData));
  }, [dispatch])

  const handleOpenNewSource = (e) => {
    setOpenSource(true);
    setMode('Create');
  }

  const handleCloseNewSource = (e) => {
    setOpenSource(false);
  }

  const handleEdit = (source) => {
    let formData = new FormData();
    formData.append("id", source.id);
    dispatch(getSource(formData))
      .then(res => {
        setMode('Edit');
        setOpenSource(true);
      })
      .catch(err => console.log(err));
  }

  const handleDelete = (id) => {
    dispatch(deleteSource(id))
      .then(res => window.alert("DELETE OK"))
      .catch(err => console.log(err))
  }

  return (
    <Box className='w-full flex flex-column flex-basis flex-gap' >
      <Box sx={{paddingTop: 2, paddingLeft: 2}}>
        <Typography 
          sx={{ 
            fontSize: 24, 
            fontWeight: 600, 
            color: '#4A85F6'
          }}
        >
          Data Source
        </Typography>
      </Box>
      <Box sx={{paddingTop: 2, gap: 2}} className='flex flex-row align-center'>
        <CTextField
          label=""
          id="search-text-field"
          placeholder='Search'
          sx={{ m: 1, flex: 1, background: 'white'}}
          InputProps={{
            startAdornment: <InputAdornment position="start"><SearchOutlinedIcon /></InputAdornment>,
          }}
        />
        <Button
          sx={{
            textTransform: 'none',
            height: 54,
            borderRadius: 2
          }}
          endIcon={<AddIcon />}
          variant='contained'
          onClick={handleOpenNewSource}
        >
          Add New Source
        </Button>
      </Box>
      <Box className='flex-basis'>
        <Paper className='h-full flex flex-column' sx={{borderRadius: 4, margin: 1}}>
          <TableContainer className='flex-basis'>
            <Table sx={{ minWidth: 650, height: '100%' }} size="small" aria-label="a dense table">
              <TableHead sx={{ height: 64}}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Data Source</TableCell>
                  <TableCell>Create Date</TableCell>
                  <TableCell sx={{width: 120}}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {Array.from({ length: 10 }).map((_, i) => {
                const source = sources[i];
                return (
                  <TableRow
                    key={source ? source.id : 1000000+i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }}
                  >
                    {source ? (
                      <>
                        <TableCell component="th" scope="row">
                          {source.name}
                        </TableCell>
                        <TableCell><Chip label={source.type}/></TableCell>
                        <TableCell>{source.created_at}</TableCell>
                        <TableCell>
                          <CActionButton 
                            startIcon={<BorderColorIcon/>}
                            onClick={() => handleEdit(source)}
                          />
                          <CActionButton 
                            startIcon={<DeleteOutlineIcon/>}
                            onClick={() => handleDelete(source.id)}
                          />
                        </TableCell>
                      </>
                    ) : (
                      // Render empty cells for blank rows
                      <>
                        <TableCell component="th" scope="row" sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                        <TableCell sx={{borderBottom: 'none'}}></TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              height: 80,
              paddingLeft: 8,
              paddingRight: 8,
              borderTop: '1px solid rgba(224, 224, 224, 1)'
            }}
            className='flex flex-row align-center justify-between'
          >
            <CPageArrowButton startIcon={<ArrowBackIcon/>} >Previous</CPageArrowButton>
            <Box sx={{color: '#f5f5f5'}}>
              <CPageButton sx={{border: '1px solid #f1f1f1'}}>1</CPageButton>
              <CPageButton>2</CPageButton>
              <CPageButton>3</CPageButton>
              <CPageButton>...</CPageButton>
              <CPageButton>8</CPageButton>
              <CPageButton>9</CPageButton>
              <CPageButton>10</CPageButton>
            </Box>
            <CPageArrowButton endIcon={<ArrowForwardIcon/>} >Next</CPageArrowButton>
          </Box>
        </Paper>
      </Box>
      <SourceModal open={openSource} mode={mode} handleClose={handleCloseNewSource} />
    </Box>
  );
}